import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const WarningText = styled.div(props => ({
    color: theme(props).semanticColors.warning.color,
}));
